import { c as _c } from "react/compiler-runtime";
import React, { ReactElement, ReactNode, RefObject, useRef, useState } from 'react';
import TooltipComponent from '@spa/components/tooltips/tooltip/tooltip.component';
import { TooltipPosition } from '@spa/components/tooltips/tooltip-fixed-trigger/useTooltipPosition';
import styles from './tooltip-cursor.component.module.scss';
interface Props {
  readonly children: ReactNode;
  readonly content?: ReactNode;
  readonly fitContent?: boolean;
}
const TooltipCursorComponent = t0 => {
  const $ = _c(14);
  const {
    children,
    content,
    fitContent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: 0,
      y: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [tooltipCoordinates, setTooltipCoordinates] = useState(t1);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [position, setPosition] = useState(TooltipPosition.TOP);
  const tooltipRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      const {
        pageX,
        pageY,
        clientX,
        clientY
      } = event;
      const {
        innerWidth: viewportWidth,
        scrollX,
        scrollY
      } = window;
      const cursorX = pageX ? pageX - scrollX : clientX;
      const cursorY = pageY ? pageY - scrollY : clientY;
      const tooltipWidth = tooltipRef.current?.scrollWidth ?? 0;
      const tooltipHeight = tooltipRef.current?.scrollHeight ?? 0;
      const halfTooltipHeight = tooltipHeight / 2;
      const halfTooltipWidth = tooltipWidth / 2;
      let tooltipX = cursorX - halfTooltipWidth;
      let tooltipY = cursorY - tooltipHeight;
      setPosition(TooltipPosition.TOP);
      if (tooltipX < 0) {
        tooltipX = cursorX + 20;
        tooltipY = cursorY - halfTooltipHeight;
        setPosition(TooltipPosition.RIGHT);
      }
      if (tooltipX + tooltipWidth > viewportWidth) {
        tooltipX = cursorX - tooltipWidth;
        tooltipY = cursorY - halfTooltipHeight;
        setPosition(TooltipPosition.LEFT);
      }
      setTooltipCoordinates({
        x: tooltipX,
        y: tooltipY
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleMouseMove = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event_0 => {
      if (event_0.pointerType === "mouse") {
        handleMouseMove(event_0);
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handlePointerMove = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = event_1 => {
      if (event_1.pointerType === "mouse") {
        setTooltipVisible(true);
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handlePointerEnter = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setTooltipVisible(false);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handlePointerLeave = t5;
  let t6;
  if ($[5] !== content || $[6] !== fitContent || $[7] !== isTooltipVisible || $[8] !== position || $[9] !== tooltipCoordinates) {
    t6 = isTooltipVisible && content && <div className={styles["tooltip-cursor__tooltip"]} ref={tooltipRef} style={{
      top: tooltipCoordinates.y,
      left: tooltipCoordinates.x
    }}><TooltipComponent className="text-xs" fitContent={fitContent} position={position}>{content}</TooltipComponent></div>;
    $[5] = content;
    $[6] = fitContent;
    $[7] = isTooltipVisible;
    $[8] = position;
    $[9] = tooltipCoordinates;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t6) {
    t7 = <div className={styles["tooltip-cursor"]} onPointerMove={handlePointerMove} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave} onWheel={handleMouseMove}>{children}{t6}</div>;
    $[11] = children;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default TooltipCursorComponent;